import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {MdRadioModule} from '@angular/material';
import {AddInterpretersComponent} from './add-interpreters.component';

@NgModule({
  imports: [CommonModule, FormsModule, MdRadioModule],
  declarations: [AddInterpretersComponent],
  exports: [AddInterpretersComponent],
})
export class AddInterpretersModule {}



// WEBPACK FOOTER //
// ./src/app/booking-management/booking-form/add-interpreters/add-interpreters.module.ts